import { classes } from "./classes.js";
import {
  BANK_BAD,
  BANK_BG_NEUTRAL,
  BANK_FS_META,
  BANK_OK,
  BANK_RADIUS_PILL,
  BANK_SIGNAL,
  BANK_TEXT_2,
  BANK_WARN,
} from "./tokens.js";

/**
 * `F-0b`: a checked point's verdict (prototype `.verdict`), replacing the `Chip`-per-file of the review rows.
 *
 * `conforme · non_conforme · incertain · signale · none` (`signale` is the register's third class, D2 `.verdict.sig`). The WORD is the caller's (`label`): colour never carries the
 * verdict alone, and `data-verdict` lets a spec or a walk read it without reading a colour.
 */
export type VerdictKind = "conforme" | "non_conforme" | "incertain" | "signale" | "none";

export interface VerdictProps {
  readonly kind: VerdictKind;
  readonly label: string;
  readonly className?: string;
}

/* The kinds are the wire's values (the api's verdicts), so they are DATA and keyed as strings, not as names. */
const KINDS: ReadonlyMap<VerdictKind, string> = new Map<VerdictKind, string>([
  ["conforme", BANK_OK],
  ["non_conforme", BANK_BAD],
  ["incertain", BANK_WARN],
  ["signale", BANK_SIGNAL],
  ["none", classes(BANK_BG_NEUTRAL, BANK_TEXT_2)],
]);

export function Verdict({ kind, label, className }: VerdictProps): React.JSX.Element {
  return (
    <span
      data-kit="verdict"
      data-verdict={kind}
      className={classes(
        "inline-flex items-center gap-1.5 px-2.5 py-1 font-semibold",
        BANK_RADIUS_PILL,
        BANK_FS_META,
        KINDS.get(kind),
        className,
      )}
    >
      {label}
    </span>
  );
}
